<template>
	<form-field-wrap
	  :field-props="fieldProps"
	  :is-error="isError"
	  :field-value="fieldValue"
	  :is-switch="isSwitch"
	  :input-focus="inputFocus"
	>
		<div>
			<input class="form-field__input"
			       :class="[inputClass, fieldProps.CLASS ? 'form-field__input_'+fieldProps.CLASS : 'form-field__input_'+fieldProps.CODE, (fieldValue || inputFocus) ? 'is-fill' : '']"
			       :type="showAsText ? 'text' : 'password'"
			       autocomplete="off"
			       v-validate="rules"
			       :data-vv-as="fieldProps.TITLE"
			       :name="fieldProps.CODE"
			       :value="fieldValue"
			       :id="fieldProps.ID ? fieldProps.ID : fieldProps.CODE"
			       @input="changeValue"
			       @focus="labelSwitch('focus')"
			       @blur="labelSwitch">
			<div class="form-field__desc">
				<span class="icon"
				      v-if="eye"
				      :class="showAsText ? 'icon--eye-closed' : 'icon--eye-open'"
				      @click="showAsText = !showAsText"
				></span>
			</div>
		</div>
		<slot name="desc"></slot>
	</form-field-wrap>
</template>
<script>
	export default {
		name: "FormFieldPassword",
		props: {
			fieldProps: {
				type: [Object, Array],
				default: function () {
					return {}
				}
			},
			eye: {
				type: Boolean,
				default: true
			}
		},
		data: function () {
			return {
				showAsText: false,
				inputFocus: false,
				inputValue: "",
				error: false,
			}
		},
	};
</script>